<template>
  <transition name="reader-settings">
    <aside v-if="visible" class="reader-settings-panel" @click.stop>
      <header>
        <div>
          <small>READING MODE</small>
          <strong>{{ $t("readerSettings.title") }}</strong>
        </div>
        <button :aria-label="$t('notice.close')" @click="$emit('close')"><i class="el-icon-close" /></button>
      </header>

      <section class="setting-row">
        <span>{{ $t("readerSettings.fontSize") }}</span>
        <div class="font-control">
          <button :disabled="fontSize <= 14" :aria-label="$t('readerSettings.decreaseFont')" @click="$emit('font-change', fontSize - 1)">A−</button>
          <b>{{ fontSize }}</b>
          <button :disabled="fontSize >= 24" :aria-label="$t('readerSettings.increaseFont')" @click="$emit('font-change', fontSize + 1)">A＋</button>
        </div>
      </section>

      <section class="setting-row">
        <span>{{ $t("readerSettings.lineSpacing") }}</span>
        <div class="spacing-control">
          <button
            v-for="option in lineHeightOptions"
            :key="option.value"
            :class="{ active: Number(lineHeight) === option.value }"
            @click="$emit('line-height-change', option.value)"
          >{{ $t(option.label) }}</button>
        </div>
      </section>

      <section class="theme-setting">
        <span>{{ $t("readerSettings.background") }}</span>
        <div>
          <button
            v-for="option in themeOptions"
            :key="option.value"
            :class="[`theme-${option.value}`, { active: theme === option.value }]"
            :aria-label="$t(option.label)"
            @click="$emit('theme-change', option.value)"
          ><i /><small>{{ $t(option.label) }}</small></button>
        </div>
      </section>
    </aside>
  </transition>
</template>

<script>
export default {
  name: "ReaderSettings",
  props: {
    visible: { type: Boolean, default: false },
    fontSize: { type: Number, default: 17 },
    lineHeight: { type: Number, default: 2 },
    theme: { type: String, default: "paper" }
  },
  data() {
    return {
      lineHeightOptions: [
        { value: 1.7, label: "readerSettings.spacingCompact" },
        { value: 2, label: "readerSettings.spacingComfortable" },
        { value: 2.3, label: "readerSettings.spacingRelaxed" }
      ],
      themeOptions: [
        { value: "paper", label: "readerSettings.themePaper" },
        { value: "eye", label: "readerSettings.themeEye" },
        { value: "night", label: "readerSettings.themeNight" }
      ]
    }
  }
}
</script>

<style scoped>
.reader-settings-panel{position:absolute;z-index:8;top:calc(59px + env(safe-area-inset-top));right:12px;left:12px;padding:16px;border:1px solid var(--reader-border);border-radius:18px;color:var(--reader-text);background:var(--reader-panel);box-shadow:0 22px 55px rgba(30,20,12,.25);backdrop-filter:blur(20px)}header{display:flex;align-items:center;justify-content:space-between;padding-bottom:13px;border-bottom:1px solid var(--reader-border)}header small,header strong{display:block}header small{color:var(--reader-accent);font-size:7px;letter-spacing:1.8px}header strong{margin-top:3px;font-size:13px}header button{width:34px;height:34px;color:var(--reader-muted);font-size:15px}.setting-row{min-height:52px;display:flex;align-items:center;justify-content:space-between;gap:14px;border-bottom:1px solid var(--reader-border)}section>span{flex:none;color:var(--reader-muted);font-size:10px}.font-control,.spacing-control{display:flex;align-items:center;gap:6px}.font-control button,.spacing-control button{height:32px;min-width:38px;padding:0 10px;border:1px solid var(--reader-border);border-radius:10px;color:var(--reader-text);background:rgba(127,105,78,.07);font-size:10px}.font-control b{min-width:24px;color:var(--reader-accent);font-size:11px;text-align:center}.font-control button:disabled{opacity:.28}.spacing-control button.active{border-color:var(--reader-accent);color:var(--reader-accent);background:rgba(141,99,61,.12)}.theme-setting{padding-top:13px}.theme-setting>div{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin-top:10px}.theme-setting button{min-width:0;padding:8px 6px;border:1px solid transparent;border-radius:12px;color:var(--reader-muted)}.theme-setting button.active{border-color:var(--reader-accent);background:rgba(141,99,61,.1)}.theme-setting i{display:block;height:30px;border:1px solid rgba(44,35,27,.13);border-radius:8px}.theme-setting small{display:block;margin-top:6px;overflow:hidden;font-size:8px;white-space:nowrap;text-overflow:ellipsis}.theme-paper i{background:#f2eadb}.theme-eye i{background:#dfe7d3}.theme-night i{border-color:#313640;background:#171a20}.reader-settings-enter-active,.reader-settings-leave-active{transition:opacity .2s ease,transform .2s ease}.reader-settings-enter,.reader-settings-leave-to{opacity:0;transform:translateY(-8px) scale(.98)}@media(max-width:340px){.reader-settings-panel{right:8px;left:8px;padding:13px}.spacing-control button{min-width:32px;padding:0 7px}}
</style>
